import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import type { User } from './auth';

// Auth do app nativo (Capacitor bundle-mode). O APK roda o SPA embarcado e fala
// com a API por Bearer JWT (não cookie). Guardamos o token + o último perfil em
// Preferences pra: (a) anexar o header em toda chamada; (b) renderizar o shell
// offline no boot (identidade vinda do cache, sem rede). Na web tudo isto é no-op
// (isNative()=false) e o fluxo segue no cookie.

const TOKEN_KEY = 'hub_token';
const PROFILE_KEY = 'hub_profile';

let _token: string | null = null;
let _profile: User | null = null;
let _hydrated = false;

export function isNative(): boolean {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}

// Espelhos síncronos — o api-client precisa anexar o header sem await por chamada.
export function tokenSync(): string | null {
  return _token;
}
export function profileSync(): User | null {
  return _profile;
}

export async function hydrateNativeAuth(): Promise<void> {
  if (_hydrated) return;
  _hydrated = true;
  if (!isNative()) return;
  try {
    _token = (await Preferences.get({ key: TOKEN_KEY })).value || null;
    const p = (await Preferences.get({ key: PROFILE_KEY })).value;
    _profile = p ? (JSON.parse(p) as User) : null;
  } catch {
    /* primeira execução / storage vazio */
  }
}

export async function setToken(token: string): Promise<void> {
  _token = token;
  if (isNative()) {
    try {
      await Preferences.set({ key: TOKEN_KEY, value: token });
    } catch {
      /* ignore */
    }
  }
}

export async function cacheProfile(user: User): Promise<void> {
  _profile = user;
  if (isNative()) {
    try {
      await Preferences.set({ key: PROFILE_KEY, value: JSON.stringify(user) });
    } catch {
      /* ignore */
    }
  }
}

export async function clearNativeAuth(): Promise<void> {
  _token = null;
  _profile = null;
  if (isNative()) {
    try {
      await Preferences.remove({ key: TOKEN_KEY });
    } catch {
      /* ignore */
    }
    try {
      await Preferences.remove({ key: PROFILE_KEY });
    } catch {
      /* ignore */
    }
  }
}
